"use client";

import { createContext, useContext } from "react";
import { ReactNode } from "react";

export type RouterContextType = {
  appRouterPathPrefixes: string[];
  siteBasePath: string;
};

type RouterProviderProps = {
  appRouterPathPrefixes: string[];
  siteBasePath: string;
  children: ReactNode;
};

const RouterContext = createContext<RouterContextType | null>(null);

export const RouterProvider = ({
  appRouterPathPrefixes,
  siteBasePath,
  children,
}: RouterProviderProps) => {
  return (
    <RouterContext.Provider value={{ appRouterPathPrefixes, siteBasePath }}>
      {children}
    </RouterContext.Provider>
  );
};

export const useRouterContext = () => {
  const context = useContext(RouterContext);

  if (!context) {
    throw new Error("useRouterContext must be used within a RouterProvider");
  }
  return context;
};
